import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Certificate: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
      fill="none"
      viewBox="0 0 37 45"
    >
      <g>
        <path
          fill={color ?? 'currentColor'}
          d="M35.4036 -0.000118166H1.59559C1.17245 -0.000118166 0.766632 0.167976 0.467424 0.467184C0.168216 0.766392 0.00012207 1.17221 0.00012207 1.59535V42.7425C0.00012207 43.1656 0.168216 43.5714 0.467424 43.8706C0.766632 44.1698 1.17245 44.3379 1.59559 44.3379H35.4036C35.8267 44.3379 36.2325 44.1698 36.5317 43.8706C36.8309 43.5714 36.999 43.1656 36.999 42.7425V1.59535C36.999 1.17221 36.8309 0.766392 36.5317 0.467184C36.2325 0.167976 35.8267 -0.000118166 35.4036 -0.000118166ZM33.8081 41.147H3.19106V3.19082H17.8614V15.6833C17.8616 15.9838 17.9466 16.2782 18.1067 16.5325C18.2669 16.7867 18.4955 16.9907 18.7664 17.1207C19.0374 17.2507 19.3395 17.3016 19.638 17.2675C19.9366 17.2334 20.2194 17.1156 20.454 16.9278L24.4427 13.7369L28.1601 16.872C28.3919 17.0683 28.675 17.1943 28.976 17.2353C29.277 17.2763 29.5834 17.2305 29.8593 17.1033C30.135 16.9757 30.3686 16.772 30.5325 16.5163C30.6964 16.2605 30.7839 15.9632 30.7847 15.6594V3.19082H33.832L33.8081 41.147ZM27.5698 12.2451L25.4718 10.4741C25.1863 10.2395 24.8282 10.1112 24.4586 10.1112C24.0891 10.1112 23.731 10.2395 23.4455 10.4741L21.0523 12.3967V3.19879H27.5698V12.2451Z"
        />
        <path
          fill={color ?? 'currentColor'}
          d="M29.1654 20.5727H7.10806C6.68491 20.5727 6.2791 20.7408 5.97989 21.04C5.68068 21.3392 5.51259 21.745 5.51259 22.1682C5.51259 22.5913 5.68068 22.9971 5.97989 23.2963C6.2791 23.5955 6.68491 23.7636 7.10806 23.7636H29.1654C29.5885 23.7636 29.9944 23.5955 30.2936 23.2963C30.5928 22.9971 30.7609 22.5913 30.7609 22.1682C30.7609 21.745 30.5928 21.3392 30.2936 21.04C29.9944 20.7408 29.5885 20.5727 29.1654 20.5727Z"
        />
        <path
          fill={color ?? 'currentColor'}
          d="M29.1654 26.819H7.10806C6.68491 26.819 6.2791 26.9871 5.97989 27.2863C5.68068 27.5855 5.51259 27.9913 5.51259 28.4145C5.51259 28.8376 5.68068 29.2434 5.97989 29.5426C6.2791 29.8419 6.68491 30.0099 7.10806 30.0099H29.1654C29.5885 30.0099 29.9944 29.8419 30.2936 29.5426C30.5928 29.2434 30.7609 28.8376 30.7609 28.4145C30.7609 27.9913 30.5928 27.5855 30.2936 27.2863C29.9944 26.9871 29.5885 26.819 29.1654 26.819Z"
        />
        <path
          fill={color ?? 'currentColor'}
          d="M29.1654 33.0575H7.10806C6.68491 33.0575 6.2791 33.2256 5.97989 33.5248C5.68068 33.824 5.51259 34.2299 5.51259 34.653C5.51259 35.0761 5.68068 35.482 5.97989 35.7812C6.2791 36.0804 6.68491 36.2485 7.10806 36.2485H29.1654C29.5885 36.2485 29.9944 36.0804 30.2936 35.7812C30.5928 35.482 30.7609 35.0761 30.7609 34.653C30.7609 34.2299 30.5928 33.824 30.2936 33.5248C29.9944 33.2256 29.5885 33.0575 29.1654 33.0575Z"
        />
      </g>
    </svg>
  </IconWrapper>
);

Certificate.displayName = 'Certificate';
